<template>
  <div>
    <div class="container">
      <h1 class="py-3 text-center text-secondary">Accesos visualizar</h1>

      <button @click="Modificar" class="custom-button">
        Click para pestaña registrar accesos de trabajador
      </button>
      <div class="mt-2">
        <div class="row gy-2">
          
          <div class="col col-5">
            <select @change="DocumentoParams($event)" class="form-select p-2 mt-2" aria-label="Default select example">
              <option selected disabled>seleccion Dni</option>

              <option
                v-for="documentoIdentidad in trabajadores"
                :key="documentoIdentidad.id"
                :value="documentoIdentidad.trabNroDoi"
              >
                {{ documentoIdentidad.nombre }}
              </option>
            </select>
          </div>
            <!-- <div class="custom-input mx-4  col col-4">
              <svg
              @click="actualizarLista(dniUsuarios)"
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                class="bi bi-search mt-3"
                viewBox="0 0 16 16"
              >
                <path
                  d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                />
              </svg>
              <input
                type="number"
                v-on:keyup.enter="actualizarLista(dniUsuarios)"
                v-model="dniUsuarios"
                class="mt-2 mx-3 custom-input__input"
                placeholder="INSERTAR DNI"
              />

              <span class="custom-input__icon"></span>
            </div> -->
          

        </div>
      </div>
      <div v-if="modificarCentro" class="row gx-3">
        <div class="col-3 mt-4">
          <div
            :class="{ 'bg-cajita': empresaValor == empresas.id }"
            class="d-flex mt-2 align-items-center border border-3 rounded cursor "
            v-for="empresas in empresa"
            :key="empresas.id"
          >
            <div
              @click="CentroCostos(empresas.id)"
              class="mx-2 w-100  text-start"
            >
              <p class="mx-2 tamaño my-0 d-flex align-items-center">
                {{ empresas.empRazSocial }}
              </p>
            </div>
            <div class="mx-2">
              <button
                :class="{
                  'btn btn-secondary': empresas.visualizar == true,
                  'btn btn-white': empresas.visualizar == false,
                }"
                class="border border-2 px-2"
                @click="
                  Empresa(
                    empresas.visualizar,
                    empresas.idTrab,
                    empresas.id,
                    empresas
                  )
                "
              ></button>
            </div>
          </div>
        </div>

        <div v-if="centro" class="col-3 mt-4">
          <div
            :class="{ 'bg-cajita': centroCostosValor == centros.idCentro }"
            class="d-flex mt-2 align-items-center border border-3 rounded cursor"
            v-for="centros in CentroDeCosto"
            :key="centros.id"
          >
            <div
              class="mx-3 w-100 text-start"
              @click="SubCentroCostos(centros.idCentro, centros.cenCodigo)"
            >
              <p class="mx-2 tamaño my-0 d-flex align-items-center">
                {{ centros.cenNombre }}
              </p>
            </div>

            <div class="mx-2 ">
              <button
                @click="
                  EliminarCosto(
                    centros.visualizar,
                    centros.idTrab,
                    centros.cenCodigo
                  )
                "
                :class="{
                  'btn btn-secondary': centros.visualizar == true,
                  'btn btn-white': centros.visualizar == false,
                }"
                class="btn btn-white border border-2 px-2"
              ></button>
            </div>
          </div>
        </div>

        <div v-if="subCentro" class="col-3 mt-4">
          <div
            :class="{ 'bg-cajita': subCentroCostosValor == subCentro.id }"
            class="d-flex mt-2 align-items-center border border-3 rounded cursor"
            v-for="subCentro in subCentroDeCostos"
            :key="subCentro.id"
          >
            <div
              class="mx-3 w-100 text-start"
              @click="SubSubCentroCostos(subCentro.id, subCentro.cenSubCentro)"
            >
              <p class="mx-2 tamaño my-0 d-flex align-items-center">
                {{ subCentro.cenNombre }}
              </p>
            </div>
            <div class="mx-2">
              <button
                @click="
                  EliminarSubCentro(subCentro.visualizar, subCentro.idTrab)
                "
                :class="{
                  'btn btn-secondary': subCentro.visualizar == true,
                  'btn btn-white': subCentro.visualizar == false,
                }"
                class="btn btn-white border border-2 px-2"
              ></button>
            </div>
          </div>
        </div>

        <div v-if="subSubCentro" class="col-3">
          <div
            :class="{
              'bg-cajita': subSubCentroCostosValor == subSubCentro.id,
            }"
            class="d-flex mt-2 align-items-center border border-3 rounded cursor"
            v-for="subSubCentro in subSubCentroDeCostos"
            :key="subSubCentro.id"
          >
            <div class="mx-3 w-100 text-start">
              <p c class="mx-2 tamaño my-0 d-flex align-items-center">{{ subSubCentro.cenSubSubNombre }}</p>
            </div>
            <div class="mx-2">
              <button
                @click="
                  EliminarSubSubCentro(
                    subSubCentro.idTrab,
                    subSubCentro.visualizar
                  )
                "
                :class="{
                  'btn btn-secondary': subSubCentro.visualizar == true,
                  'btn btn-white': subSubCentro.visualizar == false,
                }"
                class="btn btn-white border border-2 px-2"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SolimanologAccessVisualizar",

  data() {
    return {
      empresa: [],
      CentroDeCosto: [],
      subCentroDeCostos: [],
      subSubCentroDeCostos: [],
      empresaValor: "",
      centroCostosValor: "",
      subCentroCostosValor: "",
      subSubCentroCostosValor: "",
      codCentroCosto: "",
      codSubCentroCosto: "",
      centro: false,
      subCentro: false,
      subSubCentro: false,
      modificarCentro: true,
      // EliminarCentro: false,
      LimpiarEpresa: [],
      limpiarCentroCosto: [],
      limpiarSubCentroCosto: [],

      dniUsuarios: "",
      trabajadores: [],
    };
  },

  mounted() {
    this.axios.get(`TrabAcceso/ObtenerDocumentosDeIdentidad`).then((r) => {
      console.log(r.data);
      this.trabajadores = r.data;
    });
  },

  created() {},

  methods: {
    DocumentoParams(event){
      this.dniUsuarios = event.target.value
      this.getAttributes();

      this.CentroDeCosto = []
      this.subCentroDeCostos = []
      this.subSubCentroDeCostos = []
    },
    // actualizarLista(enter) {
    //   console.log(enter);
    // },
    getAttributes() {
      this.axios.get(`Empresa/EmpresaAcceso/${this.dniUsuarios}`).then((r) => {
        this.empresa = r.data;
        console.log(r.data);
      });
    },
    CentroCostos(idEmpresa) {
      this.empresaValor = idEmpresa;
      console.log(this.empresaValor);
      this.axios
        .get(
          `Ccosto/CcxTrabajdorAcceso?idEmpresa=${idEmpresa}&dniUser=${this.dniUsuarios}`
        )
        .then((r) => {
          this.CentroDeCosto = r.data;
          this.centro = true;
          this.subCentro = false;
          this.subSubCentro = false;
          console.log(r.data);
        });
    },

    SubCentroCostos(idCentro, cenCodigo) {
      this.centroCostosValor = idCentro;
      this.codCentroCosto = cenCodigo;
      this.axios
        .get(
          `SubCentro/AccesoScxTrabajador?codCenCosto=${cenCodigo}&dniUser=${this.dniUsuarios}&idEmpresa=${this.empresaValor}`
        )
        .then((r) => {
          this.subCentroDeCostos = r.data;
          this.subCentro = true;
          this.subSubCentro = false;
          console.log(r.data);
        });
    },

    SubSubCentroCostos(id, cenCodigo) {
      this.subCentroCostosValor = id;
      this.codSubCentroCosto = cenCodigo;
      console.log(cenCodigo);
      this.axios
        .get(
          `SubSubCentro/AccesoSscxTrabajador?idEmpresa=${this.empresaValor}&dniUser=${this.dniUsuarios}&codCentro=${this.codCentroCosto}&codSubCentro=${cenCodigo}`
        )
        .then((r) => {
          console.log(r.data);
          this.subSubCentroDeCostos = r.data;
          this.subSubCentro = true;
        });
    },

    Empresa(visualizar, id, idEmpresa, empre) {
      console.log(visualizar);
      console.log(id, empre);
      if (visualizar == true) {
        this.axios
          .get(
            `Empresa/ListaIdsVisual?idEmpresa=${idEmpresa}&Dni=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);

            for (let index of r.data) {
              this.LimpiarEpresa.push(index.idTrab);
              console.log(this.LimpiarEpresa);
              if (r.data.length == this.LimpiarEpresa.length) {
                const from = {
                  id: `${this.LimpiarEpresa},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                this.axios
                  .put(`TrabAcceso/ModificarVisualbAcceso`, from)
                  .then((r) => {
                    console.log(from);
                    console.log(r.data);
                    this.getAttributes();
                    this.CentroCostos(idEmpresa);
                    this.LimpiarEpresa = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(idEmpresa);
          this.LimpiarEpresa = [];
        });
      }
    },

    EliminarCosto(visualizar, id, cenCodigo) {
      console.log(visualizar, id);

      if (visualizar == true) {
        this.axios
          .get(
            `Ccosto/IdsTrabCcostoVisual?idEmpresa=${this.empresaValor}&codCcosto=${cenCodigo}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);
            for (let index of r.data) {
              this.limpiarCentroCosto.push(index.idTrab);

              if (r.data.length == this.limpiarCentroCosto.length) {
                const from = {
                  id: `${this.limpiarCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                console.log(from);
                this.axios
                  .put(`TrabAcceso/ModificarVisualbAcceso`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.CentroCostos(this.empresaValor);
                    this.SubSubCentroCostos(
                      this.subCentroCostosValor,
                      this.codSubCentroCosto
                    );
                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(this.empresaValor);
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.LimpiarEpresa = [];
        });
      }
    },

    EliminarSubCentro(visualizar, id) {
      if (visualizar == true) {
        this.axios
          .get(
            `SubCentro/idsSccxTrabVisual?idEmpresa=${this.empresaValor}&codCenCosto=${this.codCentroCosto}&codScc=${this.codSubCentroCosto}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);
            for (let index of r.data) {
              this.limpiarSubCentroCosto.push(index.idTrab);
              if (r.data.length == this.limpiarSubCentroCosto.length) {
                const from = {
                  id: `${this.limpiarSubCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                this.axios
                  .put(`TrabAcceso/ModificarVisualbAcceso`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.SubCentroCostos(
                      this.centroCostosValor,
                      this.codCentroCosto
                    );
                    this.SubSubCentroCostos(
                      this.subCentroCostosValor,
                      this.codSubCentroCosto
                    );

                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                    this.limpiarSubCentroCosto = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubCentroCostos(this.centroCostosValor, this.codCentroCosto);
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      //
    },

    EliminarSubSubCentro(id, visualizar) {
      console.log(visualizar);
      if (visualizar == true) {
        const from = {
          id: `${id},`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      //
    },

    Modificar() {
      this.$router.push("/accesos");
    },
    // //
    // Eliminar() {
    //   this.EliminarCentro = true;
    //   this.modificarCentro = false;
    // },
  },
};
</script>

<style scoped>
.bg-cajita {
  background: rgb(229, 230, 255);
}
.cursor {
  cursor: pointer;
}

.tamaño {
  font-size: 0.6rem;
}
/* input[type="number"] {
  border: 2px solid #ccc;
  border-radius: 5px;
  padding: 8px;
  font-size: 16px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
} */
.custom-button {
  background-color: #2c5b9e;
  color: #ffffff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.custom-input {
  display: flex;
}

.custom-input__input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  width: 100%;
}

.custom-input__input:focus {
  outline: none;
  border-color: #5696f7;
  box-shadow: 0 0 5px rgba(236, 229, 231, 0.5);
}

.texto-peque {
  font-size: 0.65rem;
  text-align: left;
}
</style>
